import { gql } from '@apollo/client';

import PAYMENT_PENDING_PAYMENT from './PAYMENT_PENDING_PAYMENT';

export default gql`
  mutation CancelPayments(
    $bookingReference: String!
    $currency: Currency
    $paymentLocation: String
    $hasHotel: Boolean
    $customerId: String
    $shouldCancelLoyalty: Boolean
  ) {
    cancelPayments(
      bookingReference: $bookingReference
      paymentLocation: $paymentLocation
      currency: $currency
      hasHotel: $hasHotel
      location: EBSC
      customerId: $customerId
      shouldCancelLoyalty: $shouldCancelLoyalty
    ) {
      reference
      status
      totalPriceToBePaid: totalPriceToBePaidWithCurrency(currency: $currency)
      customer {
        email
        firstName
        lastName
      }
      payments(onlyProvisional: true) {
        ...PaymentPendingPayment
      }
      amountDue: amountDueWithCurrency(currency: $currency) {
        amount
        currency
      }
      onHold: onHoldWithCurrency(currency: $currency) {
        depositAmount
      }
    }
  }

  ${PAYMENT_PENDING_PAYMENT}
`;
